import axios from "../config/axios";
import { useQuery } from "react-query";

// [1] checked
// INPUT
// book_category: text
const getBookList = async(cat:string|undefined) =>{
  const res = await axios.GENERAL.post(
    "/books", { "book_category": cat})
  if (res.status === 200) {
    // console.log("getBookList", res)
    return res.data
  }
}
// [2] checked
const getBookById = async(book_id:string|undefined) => {
  const res = await axios.GENERAL.get(
    "/book/info/"+book_id
  )
  if (res.status === 200) {
    console.log("getBookById", res)
    return res.data
  }
}
// [3] 보류
// INPUT
// BOOK.book_title(requirement)
// BOOK.publish_year(optional) if NULL, select ALL
// BOOK.publish_date(optional) if NULL, select ALL
// BOOK.numeration(optional) if NULL, select ALL
// BOOK.book_type(optional) if NULL, select ALL
// BOOK.book_category(optional) if NULL, select ALL
const getBookSearch = async(query:any) => {
  const res = await axios.GENERAL.post(
    "/books/search_by_book_info", query
  )
  if (res.status === 200){
    console.log("getBookSearch", res)
    return res.data
  }
}

// relation
// [12]
// INPUT(AND) 2개 중 하나는 반드시 있어야 함
// school_id \ if null select All
// person_id\ if null select All
// 수정
// school_ids:[], person_ids:[]
const getBooksBySP = async(query: any) => {
  const res = await axios.GENERAL.post(
    "/books/relation", query
  );
  if (res.status === 200) {
    console.log("getBooksByP", res);
    return res.data;
  }
}
// [12-1]
const getBooksBySchoolId = async(school_id:string)=> {
  const res = await axios.GENERAL.get(
    "/books/related_by_school/" + school_id
  )
  if (res.status === 200) {
    console.log("getBooksBySchoolId", res)
    return res.data
  }
}
// [12-2]
const getBooksByPersonId = async(person_id: string) => {
  const res = await axios.GENERAL.get(
    "/books/related_by_person/" + person_id
  )
  if (res.status === 200) {
    console.log("getBooksByPersonId", res)
    return res.data
  }
}



export default {
  getBookList,
  getBookById,
  getBookSearch,
  getBooksBySchoolId,
  getBooksByPersonId,
  getBooksBySP
};
